module.exports = __webpack_public_path__ + "media/side.f37fcc5f.wav";